import React from 'react'
import logo from '../assets/images/logo-dashboard.png';

const LogoCom = () => {
    return (
        <>
            {/* <img className='open_logo' src={imgBaseURL() + generalData?.data?.logoPath} alt="logo" /> */}

            {/* Static Logo */}
            <img
                className='open_logo'
                src={logo}
                alt="logo"
                style={{ height: "60px"}}
            />
        </>
    )
}

export default LogoCom
